<template>
	<div class="coupon-panel">
		<nav-bar :border="false" :left-arrow="true" @click-left="back" title="优惠券"></nav-bar>

		<div class="coupon-content">
			<template v-if="items.length">
				<div class="coupon-item" v-for="item in items" :key="item.coupons" @click="showDialog(item)">
					<h4 class="coupon-item-title">{{item.title}}</h4>
					<div class="coupon-item-time">有效期至：{{item.expiredDate}}</div>
				</div>
			</template>
			<noList v-else></noList>
		</div>
	</div>
</template>

<script>
	import {
		getCoupon
	} from '@/api'
	import noList from '@/components/noList'
	import {
		Dialog,
		NavBar
	} from 'vant';
	export default {
		data() {
			return {
				items: [],
				couponInfo: {},
				show: false
			}
		},
		components: {
			noList,
			NavBar
		},
		async mounted() {
			var header = window.__xr_bmobdb && window.__xr_bmobdb();

			const res = await getCoupon(header);

			if (res.code === 0) {
				this.items = res.data
			}
		},
		methods: {
			back() {
				this.$router.back();
			},
			showDialog(item) {
				Dialog.alert({
					title: item.title,
					message: item.usageDescription,
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
.coupon-panel {
	min-height: 100vh;
	background: linear-gradient(180deg, #f5f7fa 0%, #e4e7ed 100%);
}

::v-deep .van-nav-bar {
	background: #fff;

	.van-nav-bar__title {
		color: #333 !important;
		font-size: 28px;
	}

	.van-icon {
		color: #333 !important;
	}
}

.coupon-content {
	padding: 20px 24px;
}

.coupon-item {
	background: linear-gradient(135deg, #059669 0%, #10b981 100%);
	border-radius: 20px;
	padding: 28px;
	margin-bottom: 20px;
	color: #fff;
	position: relative;
	overflow: hidden;
	box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3);
	transition: transform 0.2s;

	&:active {
		transform: scale(0.98);
	}

	&::before {
		content: '';
		position: absolute;
		top: -50%;
		right: -50%;
		width: 100%;
		height: 100%;
		background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
	}

	.coupon-item-title {
		padding: 0 0 16px;
		margin: 0;
		font-size: 28px;
		font-weight: 600;
		position: relative;
	}

	.coupon-item-time {
		font-size: 22px;
		color: rgba(255, 255, 255, 0.85);
		position: relative;
	}
}
</style>
